import { useMemo } from 'react';

import { usePsfSharePageData } from 'src/app/pages/psf/share/pageContext';
import { SHARE_CHANNELS } from 'src/app/pages/psf/share/shared/consts';
import { usePsfShareAvailableShareActions } from 'src/app/pages/psf/share/shared/hooks';
import type { ShareChannel } from 'src/app/pages/psf/share/shared/types';
import { useTrackView } from 'src/app/shared/hooks/tracking';

const NEW_TO_OLD_SHARE_CHANNEL_MAPPING: Partial<Record<ShareChannel, string>> = {
	copy: 'copylink',
	facebookMessenger: 'facebook_message',
	instagram: 'instagram_story',
	instagramStories: 'new_instagram_stories',
	mobileNativeShare: 'mobile_native_share',
};

export function useTrackPageView(): void {
	const {
		data: { initial, petition },
	} = usePsfSharePageData();

	const buttons = usePsfShareAvailableShareActions();

	const properties = useMemo(() => {
		const mappedButtons = buttons.map(({ channel }) => NEW_TO_OLD_SHARE_CHANNEL_MAPPING[channel] || channel);
		return {
			psf_share_button_order: mappedButtons,
			...(initial
				? {
						geo_reach: petition.geoReach ?? undefined,
						category_tags: petition.categoryTags,
						relevant_location_localized_name: petition.relevantLocationLocalizedName ?? undefined,
					}
				: {}),
			...Object.keys(SHARE_CHANNELS).reduce<Record<string, boolean>>((acc, name) => {
				// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
				const mappedName = NEW_TO_OLD_SHARE_CHANNEL_MAPPING[name as ShareChannel] || name;
				// eslint-disable-next-line no-param-reassign
				acc[`show_${mappedName}`] = mappedButtons.includes(mappedName);
				return acc;
			}, {}),
		};
	}, [buttons, petition, initial]);

	useTrackView(initial ? 'combo_psf_share_initial_view' : 'combo_psf_share_message_view', properties);
}
